function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 .071h17.924v17.701H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .157)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12.464 13.59c-.13.007-.22-.022-.305-.129-.208-.264-.43-.518-.662-.796.817-.252 1.537-.605 2.083-1.237-3.08 1.707-6.156 1.706-9.236 0 .547.63 1.264.987 2.088 1.236-.263.31-.508.605-.762.892-.03.033-.11.034-.165.03-1.394-.066-2.605-.544-3.572-1.561a.312.312 0 0 1-.066-.203c.013-1.307.256-2.577.657-3.82A13.56 13.56 0 0 1 3.53 5.626a.911.911 0 0 1 .28-.307 6.18 6.18 0 0 1 2.98-1.06c.2-.017.2-.019.356.163-1.019.301-1.988.694-2.839 1.342 3.103-1.392 6.201-1.393 9.304-.002-.848-.649-1.816-1.038-2.83-1.338.078-.148.19-.181.343-.169 1.128.095 2.146.483 3.072 1.117.06.041.115.103.15.167a13.984 13.984 0 0 1 1.566 4.637c.081.547.104 1.103.142 1.655.004.074-.043.168-.096.224-.95.99-2.136 1.453-3.495 1.534M8.96.071C4.014.072 0 4.035 0 8.92c-.001 4.883 4.01 8.85 8.955 8.853 4.952.004 8.973-3.966 8.97-8.857C17.92 4.03 13.904.07 8.96.07",
  fill: "#318E8B",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.202 8.512A1.26 1.26 0 0 0 9.906 9.75a1.242 1.242 0 0 0 1.215 1.254 1.235 1.235 0 0 0 1.262-1.224c.016-.673-.529-1.256-1.181-1.267M6.764 8.512c-.652-.015-1.212.546-1.224 1.226a1.24 1.24 0 0 0 1.22 1.266 1.245 1.245 0 0 0 1.26-1.231c.004-.689-.549-1.244-1.256-1.26",
  fill: "#318E8B"
}));

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.80a78100.svg";
export { ForwardRef as ReactComponent };